/*
    06/14/2020 - Suhas

    This is a Rate-Quote slider home page.
    From here all the other sub-pages in Rate Quote slider are shown in a step-form.

    New sub-forms are added in this aprt from its original implementation:
    1. Down Payment is separated from PurchasePrice
    2. County is separated from the CountryState form
*/

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import '../css/rate-slide.css';

import StepZilla from 'react-stepzilla';
import { useSelector } from "react-redux";

import LoanPurpose from './LoanPurpose';
import PurchasePrice from "./PurchasePrice";
import DownPayment from "./DownPayment";
import CurrentLoanBalance from "./RefinanaceForm";
import CashOutFinanceForm from './CashOutRefinanceForm';
import ZipCode from './ZipCode';
import CountryState from "./CountryState";
import StateCounty from "./StateCounty";
import CreditScore from './CreditScore';
import PropertyType from './PropertyType';
import PropertyUsed from './PropUsed';
import VARatesPoints from './VARatesPoints';
import LowerRates from "./LowerRates";
import RatesData from './RatesData';

export default function Rates(props) {
	var type = useSelector(function (state) {
		return state.nameReducer.type;
	});
	var state = useSelector(function (state) {
		return state.nameReducer;
	});
	var zipCodeRedux = useSelector(function (state) {
		return state.nameReducer.zipCode;
	});

	var branchLeadSource = props.leadSource;

	var steps = [{ name: 'LoanPurpose', component: React.createElement(LoanPurpose, { leadSource: branchLeadSource }) }];
	var PurchaseSteps = [{ name: 'LoanPurpose', component: React.createElement(LoanPurpose, { leadSource: branchLeadSource }) }, { name: 'purchasePrice', component: React.createElement(PurchasePrice, { leadSource: branchLeadSource }) }, { name: 'ZipCode', component: React.createElement(ZipCode, { leadSource: branchLeadSource }) }, { name: 'CreditScore', component: React.createElement(CreditScore, { leadSource: branchLeadSource }) }, { name: 'PropertyType', component: React.createElement(PropertyType, { leadSource: branchLeadSource }) }, { name: 'PropertyUsed', component: React.createElement(PropertyUsed, { leadSource: branchLeadSource }) }, { name: 'VARatesPoints', component: React.createElement(VARatesPoints, { leadSource: branchLeadSource }) }, { name: 'RatesData', component: React.createElement(RatesData, { leadSource: branchLeadSource, phoneNumber: props.phoneNumber, phoneText: props.phoneText, 'this': true }) }];
	var FullDocsSteps = [{ name: 'LoanPurpose', component: React.createElement(LoanPurpose, { leadSource: branchLeadSource }) }, { name: 'CurrentLoanBalance', component: React.createElement(CurrentLoanBalance, { leadSource: branchLeadSource }) }, { name: 'ZipCode', component: React.createElement(ZipCode, { leadSource: branchLeadSource }) }, { name: 'CreditScore', component: React.createElement(CreditScore, { leadSource: branchLeadSource }) }, { name: 'PropertyType', component: React.createElement(PropertyType, { leadSource: branchLeadSource }) }, { name: 'PropertyUsed', component: React.createElement(PropertyUsed, { leadSource: branchLeadSource }) }, { name: 'VARatesPoints', component: React.createElement(VARatesPoints, { leadSource: branchLeadSource }) }, { name: 'RatesData', component: React.createElement(RatesData, { leadSource: branchLeadSource, phoneNumber: props.phoneNumber, phoneText: props.phoneText, 'this': true }) }];
	var CashOutRefiSteps = [{ name: 'LoanPurpose', component: React.createElement(LoanPurpose, { leadSource: branchLeadSource }) }, { name: 'CashOutFinanceForm', component: React.createElement(CashOutFinanceForm, { leadSource: branchLeadSource }) }, { name: 'ZipCode', component: React.createElement(ZipCode, { leadSource: branchLeadSource }) }, { name: 'CreditScore', component: React.createElement(CreditScore, { leadSource: branchLeadSource }) }, { name: 'PropertyType', component: React.createElement(PropertyType, { leadSource: branchLeadSource }) }, { name: 'PropertyUsed', component: React.createElement(PropertyUsed, { leadSource: branchLeadSource }) }, { name: 'VARatesPoints', component: React.createElement(VARatesPoints, { leadSource: branchLeadSource }) }, { name: 'RatesData', component: React.createElement(RatesData, { leadSource: branchLeadSource, phoneNumber: props.phoneNumber, phoneText: props.phoneText, 'this': true }) }];

	// Add the state and county steps if the user provided a zipcode
	if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
		FullDocsSteps.splice(3, 0, { name: 'CountryState', component: React.createElement(CountryState, { leadSource: branchLeadSource }) });
		CashOutRefiSteps.splice(3, 0, { name: 'CountryState', component: React.createElement(CountryState, { leadSource: branchLeadSource }) });
		FullDocsSteps.splice(4, 0, { name: 'StateCounty', component: React.createElement(StateCounty, { leadSource: branchLeadSource }) });
		CashOutRefiSteps.splice(4, 0, { name: 'StateCounty', component: React.createElement(StateCounty, { leadSource: branchLeadSource }) });
	}

	// Add the downpayment step if the user provided a purchase price
	if (state.purchasePrice > 0) {
		PurchaseSteps.splice(2, 0, { name: 'DownPaymentForm', component: React.createElement(DownPayment, { leadSource: branchLeadSource }) });

		// Add the state and county steps if the user provided a zipcode
		if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
			PurchaseSteps.splice(4, 0, { name: 'CountryState', component: React.createElement(CountryState, { leadSource: branchLeadSource }) });
			PurchaseSteps.splice(5, 0, { name: 'StateCounty', component: React.createElement(StateCounty, { leadSource: branchLeadSource }) });
		}
	}

	if (state.purchasePrice <= 0) {
		if (zipCodeRedux === "" || zipCodeRedux === undefined || zipCodeRedux === null) {
			PurchaseSteps.splice(3, 0, { name: 'CountryState', component: React.createElement(CountryState, { leadSource: branchLeadSource }) });
			PurchaseSteps.splice(4, 0, { name: 'StateCounty', component: React.createElement(StateCounty, { leadSource: branchLeadSource }) });
		}
	}

	if (branchLeadSource !== "BANKRATE.COM") {
		PurchaseSteps.splice(PurchaseSteps.length - 1, 0, { name: 'LowerRates', component: React.createElement(LowerRates, { leadSource: branchLeadSource }) });
		FullDocsSteps.splice(FullDocsSteps.length - 1, 0, { name: 'LowerRates', component: React.createElement(LowerRates, { leadSource: branchLeadSource }) });
		CashOutRefiSteps.splice(CashOutRefiSteps.length - 1, 0, { name: 'LowerRates', component: React.createElement(LowerRates, { leadSource: branchLeadSource }) });
	}

	return React.createElement(
		React.Fragment,
		null,
		React.createElement(
			Row,
			{ className: 'justify-content-center my-2' },
			React.createElement(
				Col,
				{ lg: 12 },
				React.createElement(
					'div',
					{ className: 'step-progress text-center' },
					React.createElement(StepZilla, {
						steps: type === "PURCHASE" ? PurchaseSteps : type === "FULL DOCS REFI" ? FullDocsSteps : type === "CASH OUT REFI" ? CashOutRefiSteps : steps,
						showSteps: false,
						nextButtonText: '>>',
						backButtonText: '<<',
						showNavigation: true,
						preventEnterSubmission: true,
						dontValidate: false,
						nextTextOnFinalActionStep: 'Submit',
						prevBtnOnLastStep: false })
				)
			)
		)
	);
}